import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Typography } from '@wbk/ui';

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string;
  label?: string;
  labelProps?: React.HTMLAttributes<HTMLSpanElement>;
}

const Radio = ({
  type = 'radio',
  className,
  checked,
  onChange,
  containerClassName,
  label,

  labelProps,
  ...props
}: RadioProps) => {
  const ref = React.useRef<HTMLInputElement>(null);
  const [isChecked, setIsChecked] = React.useState(Boolean(checked));

  // Sync internal state if `checked` prop changes (controlled mode)
  React.useEffect(() => {
    if (checked !== undefined) setIsChecked(checked);
  }, [checked]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
    onChange?.(e);
  };

  return (
    <label
      className={twMerge(
        'relative inline-flex cursor-pointer items-center gap-2',
        containerClassName
      )}
    >
      <input
        ref={ref}
        type={type}
        className={twMerge('hidden', className)}
        checked={isChecked}
        onChange={handleChange}
        {...props}
      />

      <div className='relative flex h-6 w-6 items-center justify-center rounded-full border border-[#71717A]'>
        <div
          className={twMerge(
            'absolute h-4 w-4 rounded-full transition-colors',
            isChecked ? 'bg-primary' : 'bg-transparent'
          )}
        />
      </div>

      {label && (
        <Typography
          as='span'
          variant='body-S'
          {...(labelProps as React.ComponentProps<React.ElementType>)}
          className={twMerge('select-none', labelProps?.className)}
        >
          {label}
        </Typography>
      )}
    </label>
  );
};

export default Radio;
